module.exports = __webpack_public_path__ + "static/media/Original Korean - Lamentation - Hantan.c009754a.md";